import React from "react";

const About = () => {
  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <h2
            style={{
              textAlign: "left",
              marginBottom: "20px",
              fontFamily: "Roboto",
              fontWeight: "bold",
            }}
          >
            About Graph Algorithms Visualizer
          </h2>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td
                  style={{
                    verticalAlign: "top",
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  <p
                    style={{
                      fontSize: "1.1rem",
                      lineHeight: "1.6",
                      fontFamily: "Roboto",
                      fontSize: "60%",
                    }}
                  >
                    Graph Algorithms Visualizer is a web application developed
                    by <b>Sanskruti Reddy Donthi</b> as part of Master's Project
                    at the University of Georgia advised by Dr. Shelby Funk. It
                    is designed to visualize various graph algorithms to aid in
                    learning and understanding graph theory concepts.
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    verticalAlign: "top",
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  <p
                    style={{
                      fontSize: "1.1rem",
                      lineHeight: "1.6",
                      fontFamily: "Roboto",
                      fontSize: "60%",
                    }}
                  >
                    This application utilizes React.js and Cytoscape.js
                    libraries for building user interfaces and graph
                    visualization, respectively. With Graph Algorithms
                    Visualizer, users can interactively explore graph
                    algorithms.
                  </p>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    verticalAlign: "top",
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  <p
                    style={{
                      fontSize: "1.1rem",
                      lineHeight: "1.6",
                      fontFamily: "Roboto",
                      fontSize: "60%",
                    }}
                  >
                    Feel free to connect with me on{" "}
                    <a
                      href="https://www.linkedin.com/in/sanskruti-reddy"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      LinkedIn
                    </a>
                    .
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default About;
